"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNodeConfig = exports.isNode = exports.typeGuard = exports.artifactType = exports.cloneFromTemplateArtifact = void 0;
const typeguards_1 = require("../typeguards");
const node_1 = require("./node");
Object.defineProperty(exports, "artifactType", { enumerable: true, get: function () { return node_1.artifactType; } });
var clone_1 = require("./clone");
Object.defineProperty(exports, "cloneFromTemplateArtifact", { enumerable: true, get: function () { return clone_1.cloneFromTemplateArtifact; } });
const { isNodeConfig, typeGuard, isNode } = (0, typeguards_1.createZodTypeGuards)(node_1.NodeConfigSchema, node_1.NodeTypeSchema, node_1.artifactType);
exports.isNodeConfig = isNodeConfig;
exports.typeGuard = typeGuard;
exports.isNode = isNode;
//# sourceMappingURL=index.js.map